<template>
  <div class="geofence-empty-screen">
    <div class="text">
      {{ $t("geofence.emptyListSuggestion") }}
    </div>

    <base-button class="ok-button"
                 color="primary"
                 :rounded="false"
                 @click="okBtnHandler">
        {{ $t("ok") }}
    </base-button>
  </div>
</template>

<script>
  export default {
    methods: {
      okBtnHandler() {
        if (this.$mq === 'mobile') {
          this.$router.go(-1)

          return
        }

        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .geofence-empty-screen {
    padding: 20px 30px;

    .text {
      font-style: normal;
      font-weight: normal;
      line-height: 20px;
    }

    .ok-button {
      width: 90px;
      margin: 16px auto 0;
    }
  }
</style>